import { useEffect } from "react"

import { syncCodes } from "./ReferralsStore"
import type { ReferralsManagerProps } from "../types"

/**
 * This Manager is responsible for synchronizing referral codes with the URL parameters.
 *
 * This component uses the `useEffect` hook to synchronize the referral codes whenever the `urlParams` change.
 * See @bounce/referrals/README.md for more information.
 */
export const ReferralsManager = ({ urlParams, cookieDomain }: ReferralsManagerProps) => {
  const { coupon, couponCode, ref, referralCode, rwg_token, utm_medium, utm_campaign } = urlParams ?? {}

  // Sync the referral codes with the URL params
  // Only sync when the relevant URL params change
  useEffect(() => {
    void syncCodes({
      cookieDomain,
      urlParams: {
        coupon,
        couponCode,
        ref,
        referralCode,
        rwg_token,
        utm_medium,
        utm_campaign,
      },
    })
  }, [coupon, couponCode, ref, referralCode, rwg_token, utm_campaign, utm_medium, cookieDomain])

  return null
}
